import { useRequest } from '../providers/useRequest';

import AppError from '../../errors/AppError';
import ITimeRecord from '../../interfaces/ITimeRecord';

interface IFilterFollowup {
  employeeId: number | null;
}

const usePointControlService = () => {
  const timeRecordsRequest = useRequest<ITimeRecord[]>();
  const path = 'point-control/api/time-record';

  const listByEmployeeAndDateTimeRecords = async (
    initialDate: string,
    endDate: string,
    employeeId: number,
  ): Promise<any> => {
    return await timeRecordsRequest
      .getOne({
        path: `${path}/list-by-employee-and-date/${initialDate}/${endDate}/${employeeId}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listByDateTimeRecords = async (
    initialDate: string,
    endDate: string,
    filters: IFilterFollowup,
  ): Promise<any> => {
    return await timeRecordsRequest
      .post({
        path: `${path}/list-by-date/${initialDate}/${endDate}`,
        sendAuthorization: true,
        body: { ...filters },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const createTimeRecord = async (resource: ITimeRecord) => {
    return await timeRecordsRequest
      .post({
        path: `${path}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const findTimeRecord = async (date: string | undefined, employeeId: number, action: string[]): Promise<any> => {
    return await timeRecordsRequest
      .getOne({
        path: `${path}/find-by-date/${date}/${employeeId}/${action}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const removeTimeRecord = async (id: string) => {
    return await timeRecordsRequest
      .remove({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(() => {})
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const updateStatusTimeRecord = async (employeeId: number, date: string[], status: string) => {
    return await timeRecordsRequest
      .put({
        path: `${path}/update/status`,
        sendAuthorization: true,
        body: {
          employeeId,
          date,
          status,
        },
      })
      .then(() => {})
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return {
    listByEmployeeAndDateTimeRecords,
    listByDateTimeRecords,
    findTimeRecord,
    removeTimeRecord,
    createTimeRecord,
    updateStatusTimeRecord,
  };
};

export { usePointControlService };
